import { Component, OnInit, Input, ViewEncapsulation, DoCheck } from '@angular/core';
import { AppSettings, Settings } from '../../../app.settings'; 
import { Menu } from './menu.model';
import { MenuService } from './menu.service';

@Component({
  selector: 'app-admin-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MenuService ]
})
export class MenuComponent implements OnInit,DoCheck  {
  @Input('menuItems') menuItems:Menu[] = [];
  @Input('menuParentId') menuParentId = 0;
  parentMenu:Array<any> = [];
  public settings: Settings;
  public userIn: any;
  constructor(public appSettings:AppSettings, public menuService:MenuService) { 
    this.settings = this.appSettings.settings;
  }

  ngOnInit() {     
    this.initDataMenu();
    //console.log(this.parentMenu);
  }

  onClick(menuId:number){
    this.menuService.toggleMenuItem(menuId);
    this.menuService.closeOtherSubMenus(this.menuItems, menuId);    
  }

  initDataMenu(){
    const storage = localStorage.getItem("facebook_auth");
    const storageAuth = localStorage.getItem("user");
    if (storageAuth) {
      this.userIn = JSON.parse(storageAuth);
    }

    if (storage) {
      this.userIn = JSON.parse(storage);
    }

    if(this.userIn.user_profil === "USER")
      this.parentMenu = this.menuItems.filter(item => item.parentId == this.menuParentId && item.title !="Admin"); 
    else
      this.parentMenu = this.menuItems.filter(item => item.parentId == this.menuParentId); 
  }

  ngDoCheck()
  {
    this.initDataMenu();
  }

}
